/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
}) {
  return questionnaire.map(question => {
    if ([1468].includes(question.idQuestion)) {
      const arrayCountries = [1479, 1470, 1392, 1441, 1304, 1277, 2321];
      const regulatoryRiskLocation = questionnaire.find(question => question.idQuestion === 176)?.idAnswerOption;

      question.behaviorObject.countryName = questionnaire.find(question => question.idQuestion === 176)?.answer;
      question.visibleQuestion = arrayCountries.includes(regulatoryRiskLocation) ? true : false;

      if (!arrayCountries.includes(regulatoryRiskLocation)) {
        question.answer = "";
        question.idAnswerOption = null;
      }
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
}) {
  try {
    let saveQuestionnaire = false;

    if (question.idQuestion === 176) {
      saveQuestionnaire = true;
      const { idAnswerOption } = value;
      const arrayCountries = [1479, 1470, 1392, 1441, 1304, 1277, 2321];
  
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if ([1468].includes(qst.idQuestion)) {
          qst.behaviorObject.countryName = value;
          qst.visibleQuestion = arrayCountries.includes(idAnswerOption) ? true : false;
  
          if (!arrayCountries.includes(idAnswerOption)) {
            qst.answer = "";
            qst.idAnswerOption = null;
            setFieldValue && setFieldValue(qst.key, "");
          }
        }
  
        return qst;
      })
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('FISCAL_AND_REGULATORY - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("FISCAL_AND_REGULATORY - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('FISCAL_AND_REGULATORY - handleRequestSerproCnpj - error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };